import React from 'react';
import './Configurator.scss';


function BoatSelector(props: {
  boatId: string;
  setBoatId: (boatId: string) => void;
}) {
  const [boatIdField, setBoatIdField] = React.useState('');

  React.useEffect(() => {
    setBoatIdField(props.boatId);
  }, [props.boatId]);

  return (
    <form
      className='BoatSelector'
      onSubmit={(e) => {
        e.preventDefault();
        props.setBoatId(boatIdField);
      }}
    >
      <input type='text' value={boatIdField} onChange={(e) => setBoatIdField(e.target.value)} />
      <button>Set Boat</button>
    </form>
  );
}

async function loadBoatConfig(boatId: string|number): Promise<BoatConfig> {
  let raw;
  let response = await fetch(`/wp-admin/admin-ajax.php?action=gwd_external_get_boat_config&ID=${boatId}`, {
    credentials: 'include'
  });

  let data = await response.json() as any;
  return {
    id: data.id,
    top_colors: data.top_colors,
    bottom_colors: data.bottom_colors,
    middle_colors: data.middle_colors,
    patterns: data.patterns,
    bottom_patterns: data.bottom_patterns,
    middle_patterns: data.middle_patterns,
    textures: data.textures,
    second_textures: data.second_textures,
    default_texture: data.default_texture,
    negative: data.negative,
    rendering_mode_large_preview: data.rendering_mode_large_preview,
    rendering_mode_small_preview: data.rendering_mode_small_preview,
  }
}

function Configurator(props: {
  onConfigLoaded: (config: BoatConfig) => void;
  selectedConfig: SelectedConfig;
  onSelectedConfigUpdated: (selectedConfig: SelectedConfig) => void;
}) {
  const [boatId, setBoatId] = React.useState('');
  const [isLoading, setIsLoading] = React.useState(false);
  const [config, setConfig] = React.useState<BoatConfig|undefined>(undefined)

  React.useEffect(() => {
    if (!window.URLSearchParams) {
      return;
    }

    let searchParams = new URLSearchParams(window.location.search);
    let foundBoatId = searchParams.get('boatId');
    if (foundBoatId && foundBoatId !== boatId) {
      setBoatId(foundBoatId);
    }
    else if ((window as any)._gwdBoatData) {
      let data = (window as any)._gwdBoatData as BoatConfig;
      setBoatId(`${data.id}`);
      setConfig(data);
      props.onConfigLoaded(data);
    }
  }, []);

  async function initBoatConfig(boatId: string|number) {
    if (!boatId) return;
    setIsLoading(true);
    let config = await loadBoatConfig(boatId);
    setIsLoading(false);
    console.log(config);
    setConfig(config);
    props.onConfigLoaded(config);
  }

  React.useEffect(() => {
    if (boatId && config && boatId === `${config.id}`) return;
    initBoatConfig(boatId);
  }, [boatId]);

  return (
    <div className="Configurator">
      {!boatId && <BoatSelector boatId={boatId} setBoatId={setBoatId} />}
      {!!boatId && <div>Boat ID: {boatId}</div>}
      {isLoading && <div>Loading...</div>}
      {!!config &&
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.onSelectedConfigUpdated(props.selectedConfig);
        }}
      >
        <label>Top Color
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {top_color: e.target.value}))}
            value={props.selectedConfig.top_color}
          >
          {config.top_colors.map((color, i) => (
            <option key={`top_color_${i}`} value={color.slug} selected={props.selectedConfig.top_color===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <label>Middle Color
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {middle_color: e.target.value}))}
            value={props.selectedConfig.middle_color}
          >
          {config.middle_colors.map((color, i) => (
            <option key={`middle_color_${i}`} value={color.slug} selected={props.selectedConfig.middle_color===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <label>Bottom Color
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {bottom_color: e.target.value}))}
            value={props.selectedConfig.bottom_color}
          >
          {config.bottom_colors.map((color, i) => (
            <option key={`bottom_color_${i}`} value={color.slug} selected={props.selectedConfig.bottom_color===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <label>Pattern
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {pattern: e.target.value}))}
            value={props.selectedConfig.pattern}
          >
          {config.patterns.map((color, i) => (
            <option key={`pattern_${i}`} value={color.slug} selected={props.selectedConfig.pattern===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <label>Laser Texture 1
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {texture_1: e.target.value}))}
            value={props.selectedConfig.texture_1}
          >
          {config.textures.map((color, i) => (
            <option key={`texture_${i}`} value={color.slug} selected={props.selectedConfig.texture_1===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <label>Laser Texture 2
          <select
            onChange={(e) => props.onSelectedConfigUpdated(Object.assign({}, props.selectedConfig, {texture_2: e.target.value}))}
            value={props.selectedConfig.texture_2}
          >
          {config.second_textures.map((color, i) => (
            <option key={`texture_${i}`} value={color.slug} selected={props.selectedConfig.texture_2===color.slug}>{color.name}</option>
          ))}
          </select>
        </label>
        <button>Update</button>
      </form>}
    </div>
  );
}

export { Configurator };
